export {
  PagePatternContext,
  default as PagePattern
} from './PagePattern.client';
